import { render, staticRenderFns } from "./NotificationBarOnGooglePlay.vue?vue&type=template&id=9ebc5c04&"
import script from "./NotificationBarOnGooglePlay.vue?vue&type=script&lang=ts&"
export * from "./NotificationBarOnGooglePlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports